<template>
  <el-dialog 
    v-model="visible" 
    width="900px" 
    :close-on-click-modal="false"
    :show-close="true"
    custom-class="member-info-dialog"
    @close="handleClose">
    <template #header>
      <div class="info-dialog-header">
        <div class="header-logo">
          <div class="logo-icon">
            <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
              <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
            </svg>
          </div>
        </div>
        <h3 class="info-dialog-title">完善会员信息</h3>
        <p class="info-dialog-org">山东心理咨询行业协会</p>
      </div>
    </template>
    
    <el-form ref="formRef" :model="form" :rules="rules" label-width="140px" size="default" class="member-info-form">
      <!-- 基本信息 -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="真实姓名" prop="realName">
            <el-input v-model="form.realName" placeholder="请输入真实姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别" prop="gender">
            <el-radio-group v-model="form.gender">
              <el-radio label="男">男</el-radio>
              <el-radio label="女">女</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="手机" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电子邮箱" prop="email">
            <el-input v-model="form.email" placeholder="请输入电子邮箱"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="出生日期" prop="birthday">
            <el-date-picker v-model="form.birthday" type="date" placeholder="请选择出生日期"
              format="YYYY-MM-DD" value-format="YYYY-MM-DD" style="width: 100%"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="任职单位" prop="company">
            <el-input v-model="form.company" placeholder="请输入任职单位"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="职称" prop="title">
            <el-input v-model="form.title" placeholder="请输入职称"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="所在城市" prop="city">
            <el-select v-model="form.city" placeholder="请选择所在城市" style="width: 100%">
              <el-option label="济南市" value="济南市"></el-option>
              <el-option label="青岛市" value="青岛市"></el-option>
              <el-option label="淄博市" value="淄博市"></el-option>
              <el-option label="枣庄市" value="枣庄市"></el-option>
              <el-option label="东营市" value="东营市"></el-option>
              <el-option label="烟台市" value="烟台市"></el-option>
              <el-option label="潍坊市" value="潍坊市"></el-option>
              <el-option label="济宁市" value="济宁市"></el-option>
              <el-option label="泰安市" value="泰安市"></el-option>
              <el-option label="威海市" value="威海市"></el-option>
              <el-option label="日照市" value="日照市"></el-option>
              <el-option label="临沂市" value="临沂市"></el-option>
              <el-option label="德州市" value="德州市"></el-option>
              <el-option label="聊城市" value="聊城市"></el-option>
              <el-option label="滨州市" value="滨州市"></el-option>
              <el-option label="菏泽市" value="菏泽市"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最终学历" prop="education">
            <el-radio-group v-model="form.education">
              <el-radio label="大专">大专</el-radio>
              <el-radio label="本科">本科</el-radio>
              <el-radio label="硕士">硕士</el-radio>
              <el-radio label="博士">博士</el-radio>
              <el-radio label="其他">其他</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="毕业院校" prop="graduateSchool">
            <el-input v-model="form.graduateSchool" placeholder="请输入毕业院校"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="专业" prop="major">
            <el-input v-model="form.major" placeholder="请输入专业"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="学位证书号" prop="degreeNo">
            <el-input v-model="form.degreeNo" placeholder="请输入学位证书号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="从事心理咨询的起始时间" prop="startDate">
            <el-date-picker v-model="form.startDate" type="date" placeholder="请选择起始时间"
              format="YYYY-MM-DD" value-format="YYYY-MM-DD" style="width: 100%"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 见习/实习经历 -->
      <el-divider content-position="left">见习/实习经历</el-divider>
      <div v-for="(exp, index) in form.experiences" :key="index" class="experience-item">
        <div class="exp-header">
          <span class="exp-title">第 {{ index === 0 ? '一' : index === 1 ? '二' : index + 1 }} 段经历</span>
          <el-button v-if="index > 0" type="danger" link size="small" @click="removeExperience(index)">删除</el-button>
        </div>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="时间" :prop="'experiences.' + index + '.time'">
              <el-date-picker v-model="exp.time" type="daterange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" format="YYYY-MM-DD"
                value-format="YYYY-MM-DD" style="width: 100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="见习/实习地点" :prop="'experiences.' + index + '.location'">
              <el-input v-model="exp.location" placeholder="见习/实习地点"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="督导老师姓名" :prop="'experiences.' + index + '.supervisorName'">
              <el-input v-model="exp.supervisorName" placeholder="输入老师姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="接受督导小时数" :prop="'experiences.' + index + '.supervisorHours'">
              <el-input v-model="exp.supervisorHours" placeholder="输入小时数" type="number"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <div class="add-experience-btn-wrapper">
        <el-button type="primary" plain @click="addExperience">
          <el-icon style="margin-right: 6px;"><Plus /></el-icon>
          点此可继续增加新的经历
        </el-button>
      </div>

      <!-- 其他信息 -->
      <el-divider content-position="left">其他信息</el-divider>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="此前是否已是我协会的会员" prop="isMember">
            <el-radio-group v-model="form.isMember">
              <el-radio label="是">是</el-radio>
              <el-radio label="否">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="是否有违规记录" prop="hasViolation">
            <el-radio-group v-model="form.hasViolation">
              <el-radio label="是">是</el-radio>
              <el-radio label="否">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="服务人次" prop="serviceCount">
            <el-input v-model="form.serviceCount" placeholder="服务人次" type="number"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="督导个案数" prop="caseCount">
            <el-input v-model="form.caseCount" placeholder="督导个案数" type="number"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="其它补充说明" prop="remark">
            <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 文件上传 -->
      <el-divider content-position="left">附件上传</el-divider>
      <div class="upload-section">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="证件照片" prop="photoUrl">
              <div class="upload-item">
                <el-upload
                  ref="photoUploadRef"
                  :action="uploadUrl"
                  :headers="uploadHeaders"
                  :limit="1"
                  :on-success="handlePhotoSuccess"
                  :on-error="handlePhotoUploadError"
                  :on-exceed="(files) => handleUploadExceed(files, 'photoUploadRef')"
                  :before-upload="beforePhotoUpload"
                  :show-file-list="false"
                  accept="image/jpeg,image/jpg,image/png">
                  <div class="upload-box upload-box--id-photo">
                    <el-image v-if="form.photoUrl" class="upload-preview" :src="form.photoUrl" fit="cover" />
                    <div v-else class="upload-placeholder">
                      <el-icon size="24"><Plus /></el-icon>
                      <span>上传一寸证件照片</span>
                    </div>
                  </div>
                </el-upload>
                <div class="upload-tip">一寸证件照（25×35mm）</div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="资格证书" prop="certificateUrl">
              <div class="upload-item">
                <el-upload
                  ref="certificateUploadRef"
                  :action="uploadUrl"
                  :headers="uploadHeaders"
                  :limit="1"
                  :on-success="handleCertificateSuccess"
                  :on-error="handleCertificateUploadError"
                  :on-exceed="(files) => handleUploadExceed(files, 'certificateUploadRef')"
                  :before-upload="beforeUpload"
                  :show-file-list="false"
                  accept="image/jpeg,image/jpg,image/png">
                  <div class="upload-box">
                    <el-image v-if="form.certificateUrl" class="upload-preview" :src="form.certificateUrl" fit="cover" />
                    <div v-else class="upload-placeholder">
                      <el-icon size="24"><Plus /></el-icon>
                      <span>上传证书</span>
                    </div>
                  </div>
                </el-upload>
                <div class="upload-tip">心理咨询师资格证书</div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学位证书" prop="degreeUrl">
              <div class="upload-item">
                <el-upload
                  ref="degreeUploadRef"
                  :action="uploadUrl"
                  :headers="uploadHeaders"
                  :limit="1"
                  :on-success="handleDegreeSuccess"
                  :on-error="handleDegreeUploadError"
                  :on-exceed="(files) => handleUploadExceed(files, 'degreeUploadRef')"
                  :before-upload="beforeUpload"
                  :show-file-list="false"
                  accept="image/jpeg,image/jpg,image/png">
                  <div class="upload-box">
                    <el-image v-if="form.degreeUrl" class="upload-preview" :src="form.degreeUrl" fit="cover" />
                    <div v-else class="upload-placeholder">
                      <el-icon size="24"><Plus /></el-icon>
                      <span>上传证书</span>
                    </div>
                  </div>
                </el-upload>
                <div class="upload-tip">学位证书扫描件</div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

    </el-form>

    <template #footer>
      <div class="info-dialog-footer">
        <el-button class="footer-btn footer-btn--cancel" size="large" @click="handleCancel">
          取消
        </el-button>
        <el-button 
          class="footer-btn footer-btn--primary" 
          type="primary" 
          size="large"
          :loading="submitting" 
          @click="handleSubmit">
          {{ submitting ? '提交中...' : '立即提交' }}
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { Plus } from '@element-plus/icons-vue'
import { genFileId } from 'element-plus'
import attachment from '@/api/public'

export default {
  name: 'MemberInfoDialog',
  
  components: { Plus },
  
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    initialData: {
      type: Object,
      default: () => ({})
    }
  },
  
  emits: ['update:modelValue', 'submit', 'cancel'],
  
  data() {
    return {
      uploadUrl: '',
      submitting: false,
      form: {
        realName: '',
        gender: '',
        phone: '',
        email: '',
        birthday: '',
        company: '',
        title: '',
        education: '本科',
        city: '',
        degreeNo: '',
        graduateSchool: '',
        major: '',
        startDate: '',
        experiences: [
          {
            time: [],
            location: '',
            supervisorName: '',
            supervisorHours: ''
          },
          {
            time: [],
            location: '',
            supervisorName: '',
            supervisorHours: ''
          }
        ],
        isMember: '否',
        hasViolation: '否',
        serviceCount: '',
        caseCount: '',
        remark: '',
        photoUrl: '',
        certificateUrl: '',
        degreeUrl: ''
      },
      rules: {
        realName: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' }
        ],
        gender: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        birthday: [
          { required: true, message: '请选择出生日期', trigger: 'change' }
        ],
        company: [
          { required: true, message: '请输入任职单位', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入职称', trigger: 'blur' }
        ],
        education: [
          { required: true, message: '请选择最终学历', trigger: 'change' }
        ],
        city: [
          { required: true, message: '请选择所在城市', trigger: 'change' }
        ],
        graduateSchool: [
          { required: true, message: '请输入毕业院校', trigger: 'blur' }
        ],
        major: [
          { required: true, message: '请输入专业', trigger: 'blur' }
        ],
        photoUrl: [
          { required: true, message: '请上传证件照片', trigger: 'change' }
        ]
      }
    }
  },
  
  computed: {
    visible: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
      }
    },
    uploadHeaders() {
      return {
        'Authorization': this.$store.getters['auth/token'] || 'no-token'
      }
    }
  },
  
  watch: {
    modelValue(val) {
      if (val) {
        this.loadInitialData()
      }
    }
  },
  
  mounted() {
    attachment.uploadFileUrl().then(res => {
      this.uploadUrl = res
    })
  },
  
  methods: {
    loadInitialData() {
      if (this.initialData && Object.keys(this.initialData).length > 0) {
        this.form = {
          ...this.form,
          ...this.initialData
        }
      }
    },
    
    addExperience() {
      this.form.experiences.push({
        time: [],
        location: '',
        supervisorName: '',
        supervisorHours: ''
      })
    },
    
    removeExperience(index) {
      this.form.experiences.splice(index, 1)
    },

    clearUploadFiles(refName) {
      this.$nextTick(() => {
        const uploadRef = this.$refs[refName]
        if (uploadRef && uploadRef.clearFiles) {
          uploadRef.clearFiles()
        }
      })
    },

    handleUploadExceed(files, refName) {
      const file = files && files[0]
      const uploadRef = this.$refs[refName]

      if (!file || !uploadRef) {
        return
      }

      uploadRef.clearFiles()
      file.uid = genFileId()

      this.$nextTick(() => {
        uploadRef.handleStart(file)
        uploadRef.submit()
      })
    },
    
    beforeUpload(file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isImage) {
        this.$message.error('只能上传 JPG/PNG 格式的图片！')
        return false
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB！')
        return false
      }
      return true
    },

    beforePhotoUpload(file) {
      const isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)
      const isLt2M = file.size / 1024 / 1024 <= 2

      if (!isImage) {
        this.$message.error('证件照片仅支持 JPG、PNG 格式')
        return false
      }

      if (!isLt2M) {
        this.$message.error('证件照片大小不能超过 2MB')
        return false
      }

      return new Promise((resolve, reject) => {
        const objectUrl = URL.createObjectURL(file)
        const img = new Image()

        img.onload = () => {
          const pixels = img.width * img.height
          URL.revokeObjectURL(objectUrl)

          if (pixels > 4000000) {
            this.$message.error('证件照片尺寸过大，请压缩后上传')
            reject(false)
            return
          }

          resolve(true)
        }

        img.onerror = () => {
          URL.revokeObjectURL(objectUrl)
          this.$message.error('图片读取失败，请重新选择')
          reject(false)
        }

        img.src = objectUrl
      })
    },
    
    handlePhotoSuccess(res) {
      if (res.code == 4000) {
        this.$message.error(res.msg)
      } else {
        this.form.photoUrl = res.data.url
        this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate('photoUrl'))
        this.$message.success('上传成功！')
      }
      this.clearUploadFiles('photoUploadRef')
    },
    
    handleCertificateSuccess(res) {
      if (res.code == 4000) {
        this.$message.error(res.msg)
      } else {
        this.form.certificateUrl = res.data.url
        this.$message.success('上传成功！')
      }
      this.clearUploadFiles('certificateUploadRef')
    },
    
    handleDegreeSuccess(res) {
      if (res.code == 4000) {
        this.$message.error(res.msg)
      } else {
        this.form.degreeUrl = res.data.url
        this.$message.success('上传成功！')
      }
      this.clearUploadFiles('degreeUploadRef')
    },

    handlePhotoUploadError(err) {
      this.handleUploadError(err, 'photoUploadRef')
    },

    handleCertificateUploadError(err) {
      this.handleUploadError(err, 'certificateUploadRef')
    },

    handleDegreeUploadError(err) {
      this.handleUploadError(err, 'degreeUploadRef')
    },
    
    handleUploadError(err, refName) {
      this.$message.error('上传失败，请重试！')
      console.error('上传错误：', err)
      this.clearUploadFiles(refName)
    },
    
    async handleSubmit() {
      const valid = await this.$refs.formRef.validate().catch(() => false)
      if (!valid) {
        this.$message.error('请完善必填信息')
        return
      }
      
      this.submitting = true
      
      try {
        // 准备提交数据
        const submitData = {
          name: this.form.realName,
          gender: this.form.gender,
          phone: this.form.phone,
          email: this.form.email,
          birthday: this.form.birthday,
          company: this.form.company,
          title: this.form.title,
          education: this.form.education,
          city: this.form.city,
          degree_no: this.form.degreeNo,
          graduate_school: this.form.graduateSchool,
          major: this.form.major,
          start_date: this.form.startDate,
          experiences: JSON.stringify(this.form.experiences),
          has_violation: this.form.hasViolation,
          service_count: this.form.serviceCount ? Number(this.form.serviceCount) : 0,
          case_count: this.form.caseCount ? Number(this.form.caseCount) : null,
          remark: this.form.remark,
          photo: this.form.photoUrl,
          certificate: this.form.certificateUrl,
          degree_certificate: this.form.degreeUrl
        }
        
        this.$emit('submit', submitData)
      } finally {
        this.submitting = false
      }
    },
    
    handleCancel() {
      this.$emit('cancel')
      this.visible = false
    },
    
    handleClose() {
      this.resetForm()
    },
    
    resetForm() {
      this.$refs.formRef?.resetFields()
      this.form = {
        realName: '',
        gender: '',
        phone: '',
        email: '',
        birthday: '',
        company: '',
        title: '',
        education: '本科',
        city: '',
        degreeNo: '',
        graduateSchool: '',
        major: '',
        startDate: '',
        experiences: [
          {
            time: [],
            location: '',
            supervisorName: '',
            supervisorHours: ''
          },
          {
            time: [],
            location: '',
            supervisorName: '',
            supervisorHours: ''
          }
        ],
        isMember: '否',
        hasViolation: '否',
        serviceCount: '',
        caseCount: '',
        remark: '',
        photoUrl: '',
        certificateUrl: '',
        degreeUrl: ''
      }
    },
    
    setSubmitting(val) {
      this.submitting = val
    }
  }
}
</script>

<style lang="scss" scoped>
.member-info-form {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 10px;
  margin-top: 15px;
}

.experience-item {
  background: #f8f9fa;
  padding: 20px;
  margin-bottom: 16px;
  border-radius: 8px;
  border: 1px solid #e8e9eb;
}

.exp-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e0e0e0;
  
  .exp-title {
    font-size: 14px;
    font-weight: 500;
    color: #3eaef4;
  }
}

.add-experience-btn-wrapper {
  text-align: center;
  margin: 20px 0;
}

.upload-section {
  .upload-item {
    .upload-box {
      width: 178px;
      height: 178px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: border-color 0.3s;

      &:hover {
        border-color: #3eaef4;
      }

      .upload-preview {
        width: 100%;
        height: 100%;
      }

      .upload-placeholder {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #8c939d;

        span {
          margin-top: 8px;
          font-size: 13px;
        }
      }
    }

    .upload-box--id-photo {
      width: 125px;
      height: 175px;
    }

    .upload-tip {
      margin-top: 8px;
      color: #909399;
      font-size: 12px;
      line-height: 1.5;
    }
  }
}

.info-dialog-header {
  text-align: center;
  padding-top: 10px;
  
  .header-logo {
    margin-bottom: 12px;
    
    .logo-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 56px;
      height: 56px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 50%;
      color: #fff;
    }
  }
  
  .info-dialog-title {
    font-size: 22px;
    font-weight: 600;
    color: #303133;
    margin: 8px 0;
  }
  
  .info-dialog-org {
    font-size: 14px;
    color: #909399;
  }

}

.info-dialog-footer {
  display: flex;
  justify-content: center;
  gap: 16px;
  
  .footer-btn {
    min-width: 120px;
    height: 44px;
    font-size: 15px;
    border-radius: 6px;
    
    &--cancel {
      border-color: #dcdfe6;
      color: #606266;
      
      &:hover {
        border-color: #c0c4cc;
        background: #f5f7fa;
      }
    }
    
    &--primary {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border: none;
      
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
</style>
